import customHeaders, { getSpace } from '../../../common/headers';
import { useParams } from 'react-router-dom';
import { useDataTable } from '../../../common/hooks';
import { useState, useEffect, useRef } from 'react';
import { TableBox, Tabs } from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../../store/general';
import './OnNewProducts.scss';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import { Filters } from '../Filters/Filters';
import { getValueMultiFilter } from '../../../common/filtersFunc';
import { msToLocalDate } from '../../../common/constant';
import { periodWeek } from '../../../common/constant';
import { useResponseHandler } from '../../../common/auth';

const btn_tab = [
  { label: 'По площадкам', value: 'news_by_date_and_market_name' },
  { label: 'По брендам', value: 'news_by_date_and_brands' },
  { label: 'По площадкам/брендам', value: 'news_by_market_name_and_brands' },
];

const OnNewProducts = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();

  const [pageValue, setPageValue] = useState('');
  // Фильтры     
  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [date, setDate] = useState(periodWeek());
  const [date_from, date_to] = date;
  const [isTableRequest, setIsTableRequest] = useState(false);

  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;

  // Таблица
  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!pageValue) return;

    setLoading(true);

    let sort, filtersParam;
    if (params) {
      [sort, filtersParam] = params;
    }

    const url = `https://apps1.ecomru.ru:4450/api/v1/lamoda/table/${pageValue}${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1] : ''}`;

    const body = JSON.stringify({
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      filters: filtersParam,
      product_brand_list: getValueMultiFilter(selectedBrand),
      market_name_list: getValueMultiFilter(selectedApi),
      date_from: msToLocalDate(date_from),
      date_to: msToLocalDate(date_to),
    });

    fetch(url, { method: 'POST', headers, body, signal: abortController.signal, })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController?.signal.aborted) return
        setLoading(false)
      });
  }

  const activeTab = useParams()['*'];

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);

  useEffect(() => {
    // Сброс номера страниц при перезагрузке таблицы
    paginatorRef.current?.reset();
    paginatorRef.current?.setTotal(0);
  }, [pageValue]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchTableData([], abortController);
    return () => abortController.abort();
  }, [isTableRequest, date, pageValue]);

  return (
    <div className="on-new-products">
      <TitlePage
        title='По новинкам'
      />

      <Filters
        selectedApi={selectedApi}
        setSelectedApi={setSelectedApi}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        isTableRequest={isTableRequest}
        setIsTableRequest={setIsTableRequest}
        date={date}
        setDate={setDate}
      />

      <Tabs
        tabs={btn_tab}
        pageValue={pageValue}
      />

      <TableBox
        {...tableProps}
        paginator={true}
        ref={paginatorRef}
        fetchCallback={fetchTableData}
      />
    </div>
  );
};

export { OnNewProducts };
